import { render, staticRenderFns } from "./afp.vue?vue&type=template&id=28ffa62e"
import script from "./afp.vue?vue&type=script&lang=ts"
export * from "./afp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports